import { useAemConfig } from '@as-react/common-components';
import { getHomepageUrl } from '@as-react/common-utils';
import { useEffect } from 'react';
import { useOAuth } from '../hooks/useOAuth';
const GuestRedirectContainer = () => {
    const { root } = useAemConfig();
    const { isLoggedIn, redirectToLogin, loginState } = useOAuth({ cancelUrl: getHomepageUrl(root) });
    useEffect(() => {
        if (loginState === 'PENDING') {
            return;
        }
        if (isLoggedIn) {
            return;
        }
        redirectToLogin();
    }, [isLoggedIn, loginState]);
    return null;
};
export default GuestRedirectContainer;
